import { Box, Paper, Typography, IconButton, Collapse } from "@mui/material";
import FindInPageOutlined from "@mui/icons-material/FindInPageOutlined";
import makeStyles from '@mui/styles/makeStyles';
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade";
import { modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store";
import { EstruturaListagem } from "src/components/projetos/types";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

export interface StructuresListMobileProps {
  estruturasList: EstruturaListagem[];
  handleChangeItemQuantity: (estruturaId: number, itemId: number, value: any) => void;
  handleChangeOpenedStatus: (index: number) => void;
  handleOpenModalDadosTecnicos?: ({ detalhesComponenteId }: { detalhesComponenteId?: number }) => void;
}

const useStyles = makeStyles({
  container: {
    width: '100%'
  },

  title: {
    fontSize: 16,
    fontWeight: 400,
    marginBottom: 20,
    textAlign: "left",
  },

  collapseContainer: {
    marginBottom: 20
  },
  collapseBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
    backgroundColor: "#f2f2f2",
    padding: "10px 8px",
    borderRadius: 8,
    textAlign: "left"
  },
  collapseTexto: {
    fontSize: 14,
    paddingLeft: 5
  },

  card: {
    padding: 15,
    borderRadius: 12,
    marginBottom: 25,
  },

  cardHeader: {
    display: "flex",
    alignItems: "flex-start",
    position: "relative",
    paddingLeft: 5
  },

  componenteInfo: {
    flex: 1,
    textAlign: "left",
  },

  infoTexto: {
    marginBlock: 3
  },

  attention: {
    color: "#c47a00",
    fontWeight: 600,
  },

  inputQuantidade: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    position: "relative",
    left: "-20px"
  },

  detailsButton: {
    textAlign: "right",
    position: "relative",
    top: 3,
  },

  rowBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 15
  }
});

export default function EstruturasListMobile({
  estruturasList,
  handleChangeItemQuantity,
  handleChangeOpenedStatus,
  handleOpenModalDadosTecnicos,
}: StructuresListMobileProps) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {estruturasList?.map((estrutura, index) => {
        return (
          <Collapse key={estrutura.id} className={classes.collapseContainer} in={estrutura.opened} collapsedSize={60}>
            <Box className={classes.collapseBox} onClick={() => handleChangeOpenedStatus(index)}>
              <Typography variant="body1" className={classes.collapseTexto}>
                {estrutura.nome}
              </Typography>

              <Typography>
                {estrutura.opened ? <KeyboardArrowUp /> : <KeyboardArrowDown /> }
              </Typography>
            </Box>
            {estrutura?.items?.map(item => (
              <Paper key={item.componente_id} className={classes.card} elevation={1}>
                <Box className={classes.cardHeader}>
                  <Box className={classes.componenteInfo}>
                    <Typography variant="body1" style={{ fontWeight: 600 }} className={classes.infoTexto}>
                      {item.nome}
                    </Typography>

                    {item.descricao && (
                      <Typography variant='body2' color='textSecondary' className={classes.infoTexto}>
                        <span className={classes.attention}><strong>Essa opção inclui:</strong></span> {item.descricao}
                      </Typography>
                    )}
                  </Box>
                </Box>

                <Box className={classes.rowBox}>
                  <Box className={classes.inputQuantidade}>
                    <InputQuantidade
                      value={item?.quantidade || 0}
                      onChange={(value: string) =>
                        handleChangeItemQuantity(estrutura.id, item.componente_id, value)
                      }
                    />
                  </Box>

                  <Box className={classes.detailsButton}>
                    <IconButton
                      size="large"
                      onClick={() => {
                        if (handleOpenModalDadosTecnicos) {
                          handleOpenModalDadosTecnicos({ detalhesComponenteId: item.componente_id })
                        } else {
                          modalComponentesDetalhesData$.next(item.componente_id)
                        }
                      }}
                    >
                      <FindInPageOutlined htmlColor="black" fontSize="large" />
                    </IconButton>
                  </Box>
                </Box>
              </Paper>
            ))}
          </Collapse>
        );
      })}
    </Box>
  );
}